import { Component, Host, h, JSX, Prop } from '@stencil/core'

@Component({
    tag: 'zr-shipping-information',
    styleUrl: 'zr-shipping-information.scss',
    scoped: true,
})

/**
 * ZooRoyal shipping information component.
 */
export class ZrShippingInformation {
    /**
     * Text to display (delivery information).
     */
    @Prop() displayText: string

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <div class="zr-shipping-information__icon"></div>
                <div class="zr-shipping-information__info">{this.displayText}</div>
            </Host>
        )
    }
}
